<div class="inner-page-wrapper flex flex-col items-center gap-24 py-40 md:gap-40">
    <div
        class="font-headline text-20 md:text-34 text-center leading-25 font-medium text-black empty:hidden md:leading-41"
    >
        <ng-content select="[headline]" />
    </div>

    <div class="grid grid-cols-2 gap-x-16 gap-y-24 md:grid-cols-4 lg:gap-[56px]">
        @for (item of cards(); track $index) {
            <ui-m040-c100-shop-card [isFirstView]="isFirstView()" [data]="item" />
        }
    </div>

    <div class="empty:hidden">
        <ng-content select="[link]" />
    </div>
</div>
